(function() {
  'use strict';

  angular
    .module('traineeWebApp.dashboard')
    .directive('mfColCmodule', colCModule);

  colCModule.$inject = ['$window', '$timeout'];

  function colCModule($window, $timeout) {
    var directive = {
      scope: true,
      link: link
    };

    return directive;

    /////////////////

    function link(scope, element) {
      var HEIGHT_PADDING = 60;
      var win = angular.element($window);
      var body = angular.element('body');
      var backLink = angular.element('.back-to-cmodule-list');
      var dashboardHeader = angular.element('header');
      var dashboardFooter = angular.element('footer');
      var resizeThrottle = _.throttle(onResize, 250);

      function onResize() {
        var h = body.height() - dashboardHeader.outerHeight() - dashboardFooter.outerHeight() - backLink.outerHeight();
        element.height(h - HEIGHT_PADDING);
      }

      win.on('resize', resizeThrottle);

      // trigger an initial resize
      $timeout(function() {
        win.triggerHandler('resize');
      }, 100, false);

      scope.$on('$destroy', function() {
        win.off('resize', resizeThrottle);
      });
    }
  }
})();
